export const personalInfo = {
  name: "Abhinav Kr. Singh",
  title: "Software Engineer",
  subtitle: "Full Stack Developer at PhonePe",
  location: "Bengaluru, India",
  email: "abhinav72610@gmail.com",
  phone: "+91 7061833619",
  linkedin: "https://www.linkedin.com/in/abhinav-kr-singh-490132193/",
  github: "https://github.com/abhinav72610",
  bio: "Full Stack Software Engineer experienced in building scalable applications, microservices, and high-performance APIs. Currently working with Java and microservices at PhonePe, with previous experience in React, Node.js, TypeScript, GraphQL, and backend development.",
  tagline: "Building scalable systems and performant web experiences."
};

export const experience = [
  {
    id: 1,
    company: "PhonePe",
    role: "Software Development Engineer",
    duration: "Jul 2026 – Present",
    location: "Bengaluru, India",
    description: [
      "Working as an SDE in the Insurance pod, developing and maintaining scalable Java-based microservices.",
      "Working across multiple microservices, modularizing existing code and improving maintainability, scalability, and code quality.",
      "Integrating external insurance providers and building reliable service-to-service integrations to support business workflows.",
      "Developing systems capable of handling high traffic and large-scale transaction volumes with a focus on performance and reliability.",
      "Collaborating with cross-functional teams to design, develop, debug, and deploy production-grade services."
    ],
    tech: ["Java", "Spring Boot", "Microservices", "REST APIs", "SQL", "Provider Integrations"]
  },
  {
    id: 2,
    company: "GlobalLogic",
    role: "Software Engineer",
    duration: "Sep 2023 – Jun 2026",
    location: "Bengaluru, Hybrid",
    description: [
      "Developed and maintained a Udemy-like internal learning platform used by 1000+ users, achieving 4.8/5 average feedback.",
      "Built reusable and optimized React components, reducing code redundancy by ~40% and improving initial load time by ~60% using Vite.",
      "Integrated GraphQL APIs using Apollo Client and implemented authentication and authorization using Keycloak.",
      "Designed and implemented RESTful APIs using NestJS and TypeScript with secure authentication and role-based authorization, reducing unauthorized access incidents by 40%.",
      "Migrated a monolithic system toward a microservices architecture using Azure Service Bus, increasing throughput by 50% and reducing peak-load downtime by 35%.",
      "Optimized backend APIs and database operations, contributing to a 20% reduction in API response time and 60% faster deployments."
    ],
    tech: [
      "React",
      "TypeScript",
      "JavaScript",
      "NestJS",
      "Node.js",
      "GraphQL",
      "Apollo Client",
      "Redux Toolkit",
      "Vite",
      "Azure Service Bus",
      "Microservices",
      "REST APIs"
    ]
  }
];

export const projects = [
  {
    id: 1,
    name: "Flick",
    description: "A Telegram bot that fetches live cricket scores by reverse-engineering the Cricinfo website API. Provides real-time match updates directly through Telegram messaging.",
    tech: ["Python", "Telegram Bot API", "Cricinfo API"],
    github: "https://github.com/abhinav72610",
    category: "Bot Development"
  },
  {
    id: 2,
    name: "HNCC Management Backend",
    description: "Backend system for the college's Hackathon and Coding Club built with Django. Features role-based permissions, team-specific email notifications, and seamless management of Web, App, and Game teams.",
    tech: ["Django", "Python", "REST API", "Email Integration"],
    github: "https://github.com/abhinav72610",
    category: "Backend System"
  },
  {
    id: 3,
    name: "Cricket Match Info System",
    description: "Full-stack system to fetch match details for any date by scraping Cricbuzz data. Features Express.js APIs with Redis caching for faster responses and rate limiting for security.",
    tech: ["Express.js", "Redis", "Web Scraping", "React"],
    github: "https://github.com/abhinav72610",
    category: "Full Stack"
  }
];

export const openSourceContributions = [
  {
    id: 1,
    org: "AnitaB.org",
    repo: "mentorship-backend",
    description: "Active contributor to the AnitaB.org Mentorship platform. Participated in their own Hacktoberfest event. Worked on backend improvements and issue resolution.",
    issues: [
      {
        title: "Issue #790",
        url: "https://github.com/anitab-org/mentorship-backend/issues/790"
      },
      {
        title: "Issue #779",
        url: "https://github.com/anitab-org/mentorship-backend/issues/779"
      }
    ],
    tags: ["Hacktoberfest", "Python", "Flask", "Open Source"]
  },
  {
    id: 2,
    org: "Creative Commons",
    repo: "ccos-website-source",
    description: "Contributed to the Creative Commons community website source, helping improve the open-source community platform.",
    issues: [
      {
        title: "Issue #484",
        url: "https://github.com/creativecommons/ccos-website-source/issues/484"
      }
    ],
    tags: ["Community", "Web Development", "Open Source"]
  },
  {
    id: 3,
    org: "dry-python",
    repo: "returns",
    description: "Contributed to the dry-python returns library, a set of primitives to make Python code more functional and type-safe.",
    issues: [
      {
        title: "Contributions",
        url: "https://github.com/dry-python/returns/issues"
      }
    ],
    tags: ["Python", "Functional Programming", "Type Safety"]
  }
];

export const skills = {
  languages: [
    "Java",
    "JavaScript",
    "TypeScript",
    "Python",
    "SQL",
    "C++",
    "Bash"
  ],
  frameworks: [
    "Spring Boot",
    "React.js",
    "Next.js",
    "NestJS",
    "Express.js",
    "Django",
    "Redux",
    "Jest"
  ],
  tools: [
    "Docker",
    "Sonar",
    "Redis",
    "MongoDB",
    "Kafka",
    "Azure",
    "GraphQL",
    "Git",
    "Vite"
  ]
};

export const education = {
  degree: "B.Tech in Information Technology",
  institution: "BIT Sindri, Jharkhand",
  duration: "2019 – 2023",
  cgpa: "7.96 / 10",
  achievements: [
    "Academic Excellence Certificate for sessions 2021-22 and 2022-23",
    "Research work on CNN Algorithm for object recognition model",
    "Joint Secretary of the Hackathon and Coding Club"
  ],
  coursework: [
    "Data Structures & Algorithms",
    "Object Oriented Programming",
    "Computer Networks",
    "Embedded Systems"
  ]
};